import axios from "axios";

export const getToken = async () => {
    try {
        const response = await axios.post("/get-token", {
            id: sessionStorage.getItem("token_id"),
        });

        return response.data.token
    } catch (error) {
        console.error("Error in getting token : ", error);
    }
}

export const sendPdfEmployee = async (email, pdfInput, storeName, order_number, fallbackGenerator = null) => {
    try {
        const token = await getToken();
        let pdfFile = null;
        const cleanStoreName = (storeName || '').trim() || 'Store';
        const fileName = `${cleanStoreName}_${order_number}.pdf`;
        const isUrl = typeof pdfInput === "string" && pdfInput.trim().length > 0 && pdfInput !== "#";

        if (pdfInput instanceof File) {
            pdfFile = pdfInput;
        } else if (pdfInput instanceof Blob) {
            pdfFile = new File([pdfInput], fileName, { type: "application/pdf" });
        } else if (isUrl) {
            // If it's a relative/data/blob URL, it can be fetched locally
            if (!pdfInput.startsWith("http://") && !pdfInput.startsWith("https://")) {
                try {
                    const baseURL = axios.defaults.baseURL || "";
                    const fetchUrl = `${baseURL}${pdfInput.startsWith("/") ? "" : "/"}${pdfInput}`;
                    const res = await fetch(fetchUrl);
                    if (res.ok) {
                        const blob = await res.blob();
                        if (blob && blob.size > 0) {
                            pdfFile = new File([blob], fileName, { type: "application/pdf" });
                        }
                    }
                } catch (fetchErr) {
                    console.warn("Failed to fetch local PDF file from URL:", fetchErr);
                }
            }
            // For remote URLs (such as S3 URLs stored in DB), do NOT fetch in browser to prevent CORS errors.
            // The URL is forwarded to the backend, which downloads and attaches the exact file.
        }

        // Only generate fallback PDF if NO valid PDF was provided (no File, no Blob, and no URL)
        if (!pdfFile && !isUrl && typeof fallbackGenerator === "function") {
            try {
                console.log("Generating fallback PDF for email attachment...");
                const generated = await fallbackGenerator();
                if (generated) {
                    let blob = null;
                    if (generated instanceof Blob) {
                        blob = generated;
                    } else if (typeof generated.output === "function") {
                        blob = generated.output("blob");
                    }
                    if (blob) {
                        pdfFile = new File([blob], fileName, { type: "application/pdf" });
                    }
                }
            } catch (genErr) {
                console.error("Error generating fallback PDF:", genErr);
            }
        }

        const formData = new FormData();
        formData.append("email", email || "");
        formData.append("storeName", storeName || "");
        formData.append("order_number", order_number || "");
        if (isUrl) {
            formData.append("pdf", pdfInput);
            formData.append("pdflink", pdfInput);
        }
        if (pdfFile) {
            formData.append("file", pdfFile, fileName);
        }

        const response = await axios.post("/send-pdf-employee", formData, {
            headers: {
                "x-auth-header": token,
                "Content-Type": "multipart/form-data",
            },
        });

        return response.data;
    } catch (error) {
        console.error("Error in sendPdfEmployee:", error);
        throw error;
    }
};

export const sendMailToCustomer = async (email, pdf, storeName, order_number, customerName, fallbackGenerator = null) => {
    try {
        return await sendPdfEmployee(email, pdf, storeName, order_number, fallbackGenerator);
    } catch (error) {
        console.error("Error in sending mail to customer : ", error);
        throw error;
    }
};

export const sendMailToOffice = async (pdf, storeName, order_number, fallbackGenerator = null) => {
    try {
        return await sendPdfEmployee("Danny@venettini.com", pdf, storeName, order_number, fallbackGenerator);
    } catch (error) {
        console.error("Error in sending mail to office : ", error);
        throw error;
    }
};

export const getCustomers = async () => {
    try {
        const token = await getToken();
        const response = await axios.post("/get-customers", {}, {
            headers: {
                "x-auth-header": token,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error in getting customers : ", error);
        return [];
    }
}

export const getCustomerById = async (customerId) => {
    try {
        const token = await getToken();
        const response = await axios.post("/get-customers", { customerid: customerId }, {
            headers: {
                "x-auth-header": token,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error in getting customer by id : ", error);
        return [];
    }
}
export const getProducts = async () => {
    try {
        const token = await getToken();
        const response = await axios.get("/get-products", {
            headers: {
                "x-auth-header": token,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error in getting products : ", error);
        return [];
    }
}

export const createOrder = async (ordersArr) => {
    try {
        const newobj = ordersArr.map((o) => {
            const qty = Number(o.unitQuantity || 0);
            const price = Number(o.unitFinalPrice || 0);
            const calculatedSales = (qty * price).toFixed(2);

            let factoryVal = o.factory;
            if (!factoryVal && o.styleFactory) {
                const parts = o.styleFactory.split("-");
                if (parts[0]) {
                    factoryVal = parts[0] + ".0";
                }
            }

            return {
                ...o,
                date: formatDate(o.date || new Date()),
                startDate: formatDate(o.startDate || o.date || new Date()),
                cancelDate: formatDate(o.cancelDate || o.startDate || o.date || new Date()),
                time: formatTime(new Date()),
                status: o.status || "1",
                factory: JSON.stringify(factoryVal) || null,
                sales: calculatedSales,
                revenuesTotal: calculatedSales,
                stich: o.stich || o.Stitch || null,
                season: o.season || o.Season || null,
                unitQuantity: JSON.stringify(o.unitQuantity),
                unitFinalPrice: JSON.stringify(o.unitFinalPrice),
                size: JSON.stringify(o.size)
            };
        });
        const token = await getToken();
        const response = await axios.post("/create-order", {
            "orders": newobj
        }, {
            headers: {
                "x-auth-header": token,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error in createOrder:", error);
    }
}

export const uploadSignatureImage = async (file, orderNumber) => {
    try {
        const token = await getToken();
        const formData = new FormData();
        formData.append("file", file);
        const response = await axios.post(`/upload-sign-img/${orderNumber}`, formData, {
            headers: {
                "x-auth-header": token,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error in uploading signature : ", error);
    }
}

export const uploadPDF = async (file, orderNumber) => {
    try {
        const token = await getToken();
        const formData = new FormData();
        formData.append("order_number", orderNumber);
        formData.append("file", file);
        const response = await axios.post("/upload-pdf", formData, {
            headers: {
                "x-auth-header": token,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error in uploading PDF : ", error);
    }
}

export const getPDF = async (order_id) => {
    try {
        const token = await getToken();
        const response = await axios.post("/get-pdf", {
            order_number: order_id
        }, {
            headers: {
                "x-auth-header": token,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error in getting PDF : ", error);
    }
}

export const getProductSizes = (product) => {
    try {
        if (!product) return [];

        const sizes = [];

        for (let i = 1; i <= 5; i++) {
            const sizeRange = product[`Size${i}`];
            const price = product[`Price${i}`];

            // skip if size not available
            if (!sizeRange) continue;

            // Example: "19-27"
            const [start, end] = sizeRange.split("-").map(Number);

            if (!start || !end) continue;

            for (let size = start; size <= end; size++) {
                sizes.push({
                    size,
                    sku: product.sku,
                    material: product.Material1,
                    qty: 0,
                    price: Number(price) || 0,
                });
            }
        }

        return sizes;

    } catch (error) {
        console.error("Error in getting product sizes : ", error);
        return [];
    }
};

export const getAllUniqueSizes = (products = []) => {
    try {
        if (!Array.isArray(products) || products.length === 0) return [];

        const sizes = new Set();

        products.forEach(product => {
            for (let i = 1; i <= 5; i++) {
                const sizeRange = product[`Size${i}`];

                if (!sizeRange) continue;

                // Example: "19-27"
                const [start, end] = sizeRange.split("-").map(Number);

                if (!start || !end) continue;

                for (let size = start; size <= end; size++) {
                    sizes.add(size);
                }
            }
        });

        // Convert Set to array and sort ASC
        return Array.from(sizes).sort((a, b) => a - b);

    } catch (error) {
        console.error("Error in getting unique sizes:", error);
        return [];
    }
};

export const getProductSizeRange = (product) => {
    try {
        if (!product) return Array.from({ length: 23 }, (_, i) => 19 + i);

        const sizeNums = new Set();

        // 1. Check Size1 .. Size5 fields (e.g., "24-27")
        for (let i = 1; i <= 5; i++) {
            const sizeRange = product[`Size${i}`];
            if (sizeRange && typeof sizeRange === "string" && sizeRange.includes("-")) {
                const [start, end] = sizeRange.split("-").map(Number);
                if (!isNaN(start) && !isNaN(end) && start > 0 && end >= start) {
                    for (let s = start; s <= end; s++) {
                        sizeNums.add(s);
                    }
                }
            }
        }

        // 2. Check items array if present
        if (product.items && Array.isArray(product.items)) {
            product.items.forEach((it) => {
                const s = Number(it.size);
                if (!isNaN(s) && s > 0) {
                    sizeNums.add(s);
                }
            });
        }

        // 3. Check sizes array if present (e.g. detail.sizes)
        if (product.sizes && Array.isArray(product.sizes)) {
            product.sizes.forEach((sObj) => {
                const s = Number(sObj.size);
                if (!isNaN(s) && s > 0) {
                    sizeNums.add(s);
                }
            });
        }

        if (sizeNums.size > 0) {
            const sorted = Array.from(sizeNums).sort((a, b) => a - b);
            const min = sorted[0];
            const max = sorted[sorted.length - 1];
            const range = [];
            for (let s = min; s <= max; s++) {
                range.push(s);
            }
            return range;
        }

        return Array.from({ length: 23 }, (_, i) => 19 + i);
    } catch (error) {
        console.error("Error in getProductSizeRange:", error);
        return Array.from({ length: 23 }, (_, i) => 19 + i);
    }
};


export const formatDate = (dateVal) => {
    if (!dateVal) return "";
    if (dateVal instanceof Date) {
        if (isNaN(dateVal.getTime())) return "";
        const mm = String(dateVal.getMonth() + 1).padStart(2, '0');
        const dd = String(dateVal.getDate()).padStart(2, '0');
        const yyyy = dateVal.getFullYear();
        return `${mm}-${dd}-${yyyy}`;
    }
    const rawStr = String(dateVal).trim();
    if (!rawStr) return "";

    const str = rawStr.includes("T") ? rawStr.split("T")[0] : rawStr;

    const delimiter = str.includes("/") ? "/" : str.includes("-") ? "-" : null;
    if (delimiter) {
        const parts = str.split(delimiter);
        if (parts.length === 3) {
            let year, month, day;
            if (parts[0].length === 4) {
                // YYYY-MM-DD or YYYY-DD-MM
                year = parts[0];
                const p1 = parseInt(parts[1], 10);
                const p2 = parseInt(parts[2], 10);
                if (p1 > 12) {
                    // YYYY-DD-MM
                    day = String(p1).padStart(2, '0');
                    month = String(p2).padStart(2, '0');
                } else if (p2 > 12) {
                    // YYYY-MM-DD
                    month = String(p1).padStart(2, '0');
                    day = String(p2).padStart(2, '0');
                } else {
                    // Default assume YYYY-MM-DD
                    month = String(p1).padStart(2, '0');
                    day = String(p2).padStart(2, '0');
                }
            } else if (parts[2].length === 4) {
                // MM-DD-YYYY or DD-MM-YYYY
                year = parts[2];
                const p1 = parseInt(parts[0], 10);
                const p2 = parseInt(parts[1], 10);
                if (p1 > 12) {
                    // DD-MM-YYYY
                    day = String(p1).padStart(2, '0');
                    month = String(p2).padStart(2, '0');
                } else if (p2 > 12) {
                    // MM-DD-YYYY
                    month = String(p1).padStart(2, '0');
                    day = String(p2).padStart(2, '0');
                } else {
                    // Default assume MM-DD-YYYY
                    month = String(p1).padStart(2, '0');
                    day = String(p2).padStart(2, '0');
                }
            }
            if (year && month && day) {
                const mNum = parseInt(month, 10);
                const dNum = parseInt(day, 10);
                if (mNum >= 1 && mNum <= 12 && dNum >= 1 && dNum <= 31) {
                    return `${month}-${day}-${year}`;
                }
            }
        }
    }

    const d = new Date(rawStr);
    if (!isNaN(d.getTime())) {
        const mm = String(d.getUTCMonth() + 1).padStart(2, '0');
        const dd = String(d.getUTCDate()).padStart(2, '0');
        const yyyy = d.getUTCFullYear();
        return `${mm}-${dd}-${yyyy}`;
    }

    return rawStr;
};

export const formatTime = (timeVal) => {
    if (!timeVal) {
        const now = new Date();
        const hours = String(now.getHours()).padStart(2, "0");
        const minutes = String(now.getMinutes()).padStart(2, "0");
        return `${hours}h : ${minutes}m`;
    }

    if (typeof timeVal === "string" && timeVal.includes("h") && timeVal.includes("m")) {
        return timeVal.trim();
    }

    let dateObj = timeVal instanceof Date ? timeVal : new Date(timeVal);

    if (isNaN(dateObj.getTime())) {
        if (typeof timeVal === "string" && timeVal.includes(":")) {
            const parts = timeVal.split(":");
            const h = String(parts[0]).trim().padStart(2, "0");
            const m = String(parts[1]).trim().padStart(2, "0");
            return `${h}h : ${m}m`;
        }
        dateObj = new Date();
    }

    const hours = String(dateObj.getHours()).padStart(2, "0");
    const minutes = String(dateObj.getMinutes()).padStart(2, "0");
    return `${hours}h : ${minutes}m`;
};



